import { render, staticRenderFns } from "./fdInventory55.vue?vue&type=template&id=5b17d980"
import script from "./fdInventory55.vue?vue&type=script&lang=js"
export * from "./fdInventory55.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports